import axios from "axios";

import { organizationLoaded, loadOrganization } from "./organization";
import {
  reimbursementsOverviewLoaded,
  loadReimbursementsOverview
} from "./reimbursements";

import {
  transactionsOverviewLoaded,
  loadTransactionsOverview
} from "./transactions";

import {
  hasCapability,
  VIEW_REIMBURSEMENTS,
  VIEW_TRANSACTIONS,
  MODIFY_ORGANIZATION
} from "../util/capability";

export const LOAD_STARTED = "LOAD_STARTED";
export const LOAD_FINISHED = "LOAD_FINISHED";
export const LOAD_ERRORED = "LOAD_ERROR";

export const loadStarted = () => {
  return {
    type: LOAD_STARTED
  };
};

export const loadFinished = () => {
  return {
    type: LOAD_FINISHED
  };
};

export const loadErrored = error => {
  return {
    type: LOAD_ERRORED,
    payload: error
  };
};

const loadInitialState = {
  status: "unloaded",
  error: false
};

export const loadReducer = (state = loadInitialState, action) => {
  switch (action.type) {
    case LOAD_STARTED:
      return {
        status: "loading",
        error: false
      };
    case LOAD_FINISHED:
      return {
        status: "finished",
        error: false
      };
    case LOAD_ERRORED:
      return {
        status: "error",
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoading = state => {
  return state.load.status === "unloaded" || state.load.status === "loading";
};

export const getLoadError = state => state.load.error;

export const loadApp = () => {
  return dispatch => {
    dispatch(loadStarted());
    const modules = [];
    if (hasCapability(VIEW_REIMBURSEMENTS)) {
      modules.push(
        loadReimbursementsOverview().then(reimbursementsOverview => {
          dispatch(reimbursementsOverviewLoaded(reimbursementsOverview));
        })
      );
    }
    if (hasCapability(MODIFY_ORGANIZATION)) {
      modules.push(
        loadOrganization().then(organization => {
          dispatch(organizationLoaded(organization));
        })
      );
    }
    if (hasCapability(VIEW_TRANSACTIONS)) {
      modules.push(
        loadTransactionsOverview().then(transactionsOverview => {
          dispatch(transactionsOverviewLoaded(transactionsOverview));
        })
      );
    }
    axios
      .all(modules)
      .then(() => {
        dispatch(loadFinished());
      })
      .catch(error => {
        dispatch(loadErrored(error));
      });
  };
};



// WEBPACK FOOTER //
// ./frontend/src/actions/load.js